// extracted by mini-css-extract-plugin
export default {"dashMenu":"DashboardMenu_dashMenu__CxRBM","count":"DashboardMenu_count__LNvlV","active":"DashboardMenu_active__B67HY"};